export default "__VITE_ASSET__BISxCLqo__"